module.exports = __webpack_public_path__ + "img/mmmcom.ad7b61c8.png";